// config.js

export const SALENG_GREEN_API_PROD = "https://api.saleng.tjl.co.th";
// export const SALENG_GREEN_API_DEV = "http://localhost:8001";
// export const SALENG_GREEN_API_DEV = "http://192.168.0.105:8001";
export const SALENG_SHOP_API_PROD = "https://shop-api.saleng.tjl.co.th";
// export const SALENG_SHOP_API_PROD = "http://192.168.0.102:9002";
// export const SALENG_SHOP_API_DEV = "http://192.168.0.105:8002";




